import BaseRepository from "./BaseRepository";
import st from "lib/utils/index";
import { AdminUserDecorator } from "lib/decorators/index";

export default new (class AdminUsersRepository extends BaseRepository {
  findByEmail(email) {
    return this.api
      .get(`/admin_users/find_by_email`, {
        params: { email },
      })
      .map((response) => st.api.dejsonapinize(response.data.data, response.data.included))
      .map((user) => new AdminUserDecorator(user));
  }
})();



// WEBPACK FOOTER //
// ./src/lib/repositories/AdminUsersRepository.js